import {
  SheetPageBody,
  SheetPageClose,
  SheetPageTitle,
} from "@/components/ui/sheet-page"
import { Mail } from "lucide-react"
import { NewProps } from "./page-props"
import { useTranslation } from "react-i18next"
import Flash from "@/components/ui/flash"
import { useEffect } from "react"
import { useProps } from "@/lib/page-rendering"

export default function Page() {
  const { invitation } = useProps<NewProps>()
  const { t } = useTranslation("invitations")
  const { team_profile_name } = invitation

  useEffect(() => {
    window.parent.postMessage("sheet:reload_on_close")
  })

  return (
    <SheetPageBody>
      <SheetPageTitle icon={Mail}>
        {t("response.new.title", { team_profile_name })}
      </SheetPageTitle>
      <div className="flex flex-col gap-6 p-6">
        <Flash />
        <SheetPageClose>Close</SheetPageClose>
      </div>
    </SheetPageBody>
  )
}
